//import liraries
import React, { Component, useEffect, useState } from "react";
import { View, Text, ScrollView, FlatList } from "react-native";
import CHeader from "../../common/CHeader";
import MainContainer from "../../common/CWrapper";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import CText from "../../common/CText";
import { disputeHistory, } from "../../api/apiManager";
import {  getTripTransactionList } from "../../api/tripInsurance";
import CustomButton from "../../common/CustomButton";
import { COLORS, FONTS } from "../../constant";
import CImage from "../../common/CImage";
import { isEmpty } from "lodash";
import ModalAlert from "../../common/ModalAlert";
import Loader from "../../common/Loader";
import * as RootNavigation from "../../utilities/RootNavigation"


// create a component
const TripRaiseDispueTransactions = (props) => {
  const headingData = [
    {
      id: 1,
      title: "Vehicle No.",
      width: 145
    },
    {
      id: 2,
      title: "TXN DATE",
      width: 145
    },
    {
      id: 3,
      title: "TXN TIME",
      width: 145
    },
    {
      id: 4,
      title: "TXN NO.",
      width: 145
    },
    {
      id: 5,
      title: "TXN DETAILS",
      width: 185
    },
    {
      id: 6,
      title: "DEBIT AMOUNT",
      width: 145
    },
    {
      id: 7,
      title: "CREDIT AMOUNT",
      width: 145
    },
    {
      id: 8,
      title: "BALANCE AMOUNT",
      width: 145
    },
    {
      id: 9,
      title: "ACTIONS",
      width: 145
    },
  ];


  const styles = useStyles();
  const [loading, setLoading] = useState(false)
  const [transactionData, setTransactionData] = useState([])
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [alertModal, setAlertModal] = useState({
    title: "",
    status: "",
    message: "",
    navigateScreen: "",
    actionButton: "",
  });

  const onCloseModal = () => {
    setAlertModalVisible(false);
  };

  const getTransactionList = () => {
    setLoading(true);
    getTripTransactionList().then(res => {
      setLoading(false);
      setTransactionData(res.data);
      console.log('getTransactionList:', res)
    }).catch((err) => {
      setLoading(false);
      console.log("Error:getTransactionList - ", err);
    });
  }

  const getDisputeHistory = (transId, item) => {
    setLoading(true)
    let params = { txnId: transId }
    disputeHistory(params)
      .then(res => {
        console.log('llog0-----------log--------------------log', res?.isRaiseDisputeEnabled)
        if (res?.isRaiseDisputeEnabled) {
          RootNavigation.navigate("otherServices/dispute", { screen: "CreateRiaseDispute", disputeItem: item })
          global.activeScreen = "UsedCarLoan"
          setLoading(false);
          return;
        } else {
          setAlertModal({
            title: "Error",
            status: "error",
            message: "You already raised a dispute for this transaction",
            navigateScreen: "",
            actionButton: "OK"
          });
          setAlertModalVisible(true);
          setLoading(false);
          return;

        }
      }).catch((err) => {
        setAlertModal({
          title: "Error",
          status: "error",
          message: err.message,
          navigateScreen: "",
          actionButton: "OK"
        });
        setAlertModalVisible(true);
        setLoading(false);
      })
  }

  useEffect(() => {
    getTransactionList()
  }, [])

  return (
    <MainContainer>
      <View style={styles.contentWrapper}>
        <CHeader
          showBack
          disputeHeader
          title="Raise a dispute"
          onPress={() => props.setScreen(props.info.backNavigation)}
          showDesc={true}
        />
        {
          isEmpty(transactionData)
            ? <View style={{ alignItems: "center", justifyContent: "center", marginTop: 40, }}>
              <CImage.Ti24SCancelImage />
              <CText.kycTypeText
                style={{ color: COLORS.black, paddingVertical: 20 }}
              >
                {"No Transactions Found"}
              </CText.kycTypeText>
              <CText.kycTypeText
                style={{
                  color: COLORS.black,
                  paddingBottom: 20,
                  opacity: 0.5,
                  fontFamily: FONTS.InterMedium,
                  paddingHorizontal: 60,
                  textAlign: "center",
                }}
              >
                  {"Sorry, no disputes related to trip insurance were found on your account"}
              </CText.kycTypeText>
            </View>
            : <ScrollView horizontal={true}>
              <View style={{ width: "100%", borderRadius: 20 }}>
                <View style={styles.headerViewStyle}>
                  {headingData.map((item,index) => {
                    return (
                      <View style={styles.headerViewStyle}>
                        <CText.tiTransactionText style={{ width: item.width, minWidth: item.width }} key={index}>
                          {item.title}
                        </CText.tiTransactionText>
                        <View style={styles.verticalLineStyle} />
                      </View>
                    );
                  })}
                </View>
                <FlatList
                  style={{}}
                  showsVerticalScrollIndicator
                  data={transactionData}
                  showsHorizontalScrollIndicator
                  keyExtractor = {(item, index) => index+"_"+item?.id?.toString() }
                  renderItem={({ item, index }) => {
                    return (
                      <View
                        style={[
                          styles.dataViewStyle,
                          {
                            backgroundColor:
                              index % 2 !== 0 ? "#ffffff" : "#E5E5E5",
                            borderBottomRightRadius: index == transactionData.length - 1 ? 15 : null,
                            borderBottomLeftRadius: index == transactionData.length - 1 ? 15 : null
                          },
                        ]}
                      >
                        <CText.tiTransactionText style={{ width: 145, minWidth: 145 }}>
                          {item.vrn}
                        </CText.tiTransactionText>
                        <View style={styles.verticalLineStyle} />
                        <CText.tiTransactionText style={{ width: 145, minWidth: 145 }}>
                          {item.dateTime}
                        </CText.tiTransactionText>
                        <View style={styles.verticalLineStyle} />
                        <CText.tiTransactionText style={{ width: 145, minWidth: 145 }}>
                          {item.dateTime}
                        </CText.tiTransactionText>
                        <View style={styles.verticalLineStyle} />
                        <CText.tiTransactionText style={{ width: 145, minWidth: 145 }}>
                          {item.transId}
                        </CText.tiTransactionText>
                        <View style={styles.verticalLineStyle} />
                        <CText.tiTransactionText style={{ width: 185, minWidth: 185 }}>
                          {item.tollPlaza}
                        </CText.tiTransactionText>
                        <View style={styles.verticalLineStyle} />
                        <CText.tiTransactionText style={{ width: 145, minWidth: 145 }}>
                          {item.statementType == "D" ? item.price : "-"}
                        </CText.tiTransactionText>
                        <View style={styles.verticalLineStyle} />
                        <CText.tiTransactionText style={{ width: 145, minWidth: 145 }}>
                          {item.statementType == "C" ? item.price : "-"}
                        </CText.tiTransactionText>
                        <View style={styles.verticalLineStyle} />
                        <CText.tiTransactionText style={{ width: 145, minWidth: 145 }}>
                          {item.amountBalance}
                        </CText.tiTransactionText>
                        <View style={styles.verticalLineStyle} />
                        <View style={{ alignSelf: "center", paddingHorizontal: 10 }}>
                          <CustomButton onPress={() => getDisputeHistory(item.transId, item)} skipButton text={"Raise Dispute"} width={120} height={35} borderColor={COLORS.black} padding={7} />
                        </View>
                      </View>
                    );
                  }}
                />
              </View>
            </ScrollView>
        }
      </View>
      {loading && <Loader />}
      {alertModalVisible && (
        <View style={styles.overlayViewStyle}>
          <ModalAlert
            title={alertModal.title}
            status={alertModal.status}
            message={alertModal.message}
            navigateScreen={alertModal.navigateScreen}
            actionButton={"OK"}
            onCloseModal={onCloseModal}
          />
        </View>
      )}
    </MainContainer>
  );
};

// define your styles
const useStyles = CreateResponsiveStyle({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#2c3e50",
  },
  contentWrapper: {
    width: "100%",
    height: "100%",
  },
  headerViewStyle: {
    flexDirection: "row",
    backgroundColor: "#ffffff",
  },
  verticalLineStyle: {
    width: 0.5,
    height: "100%",
    backgroundColor: "#a0a0a0",
  },
  dataViewStyle: {
    flexDirection: "row",
  },
  overlayViewStyle: {
    position: "absolute",
    zIndex: 9999,
    backgroundColor: "rgba(52,52,52,0.9)",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    borderRadius: 10,
  },
});

//make this component available to the app
export default TripRaiseDispueTransactions;
